import React from 'react';

const PortOutsTable = ({ portOuts, handleAction }) => {
  const renderTableRow = ({
    id,
    account_number,
    account_password,
    mdn,
    vendor,
    subscription_id,
    reason_code,
    validation_result,
  }) => {
    return (
      <tr key={id}>
        <td>{account_number}</td>
        <td>{account_password}</td>
        <td>{mdn}</td>
        <td>{vendor}</td>
        <td>{subscription_id}</td>
        <td>{reason_code?.replace(/_/g, ' ')}</td>
        <td>{validation_result?.replace(/_/g, ' ')}</td>
        <td style={{ width: '185px', minWidth: '185px' }}>
          <button
            onClick={() => handleAction(id, subscription_id, 'approve')}
            className="btn btn-default mar-r"
          >
            Approve
          </button>
          <button
            onClick={() => handleAction(id, subscription_id, 'reject')}
            className="btn btn-default"
          >
            Reject
          </button>
        </td>
      </tr>
    );
  };

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Account Number</th>
          <th>Account Password</th>
          <th>Mdn</th>
          <th>Vendor</th>
          <th>Sub Id</th>
          <th>Reason Code</th>
          <th>Validation Result</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {portOuts?.length ? (
          portOuts.map(renderTableRow)
        ) : (
          <tr>
            <td colSpan="8">No results</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PortOutsTable;
